import { combineReducers } from '@reduxjs/toolkit';

import { UNIT_INFO_RESPONSE } from '@unit/duck/actions';
import { resetOnLogoutReducer } from '@utils';

import {
  DISABLE_FORUM_ERROR,
  DISABLE_FORUM_REQUEST,
  DISABLE_FORUM_RESPONSE,
  GET_TIMEZONES_ERROR,
  GET_TIMEZONES_REQUEST,
  GET_TIMEZONES_RESPONSE,
  SET_TIMEZONE_ERROR,
  SET_TIMEZONE_REQUEST,
  SET_TIMEZONE_RESPONSE,
  SYNC_FORUM_ERROR,
  SYNC_FORUM_REQUEST,
  SYNC_FORUM_RESPONSE,
} from './actions';

const enableForumLoading = (state = false, { type }) => {
  switch (type) {
    case DISABLE_FORUM_REQUEST: {
      return true;
    }
    case DISABLE_FORUM_RESPONSE:
    case DISABLE_FORUM_ERROR: {
      return false;
    }
    default: {
      return state;
    }
  }
};

const forumEnabled = (state = false, { type, payload }) => {
  switch (type) {
    case UNIT_INFO_RESPONSE: {
      const { unitForums = [] } = payload;
      return unitForums.length > 0 && !!unitForums[0].discourseCategorySlug;
    }
    case DISABLE_FORUM_RESPONSE: {
      return false;
    }
    default: {
      return state;
    }
  }
};

const forumCategorySlug = (state = '', { type, payload }) => {
  switch (type) {
    case UNIT_INFO_RESPONSE: {
      const { unitForums = [] } = payload;
      return unitForums.length > 0 ? unitForums[0].discourseCategorySlug : '';
    }
    case DISABLE_FORUM_RESPONSE: {
      return '';
    }
    default: {
      return state;
    }
  }
};

const syncForumLoading = (state = false, { type }) => {
  switch (type) {
    case SYNC_FORUM_REQUEST: {
      return true;
    }
    case SYNC_FORUM_RESPONSE:
    case SYNC_FORUM_ERROR: {
      return false;
    }
    default: {
      return state;
    }
  }
};

const getTimezones = (state = [], { type, payload }) => {
  switch (type) {
    case GET_TIMEZONES_RESPONSE:
      return payload;
    case GET_TIMEZONES_REQUEST:
    case GET_TIMEZONES_ERROR: {
      return [];
    }
    default: {
      return state;
    }
  }
};

const isSettingTimezone = (state = false, { type }) => {
  switch (type) {
    case SET_TIMEZONE_REQUEST: {
      return true;
    }
    case SET_TIMEZONE_RESPONSE:
    case SET_TIMEZONE_ERROR: {
      return false;
    }
    default: {
      return state;
    }
  }
};

const isLoadingSetTimezone = (state = false, { type }) => {
  switch (type) {
    case SET_TIMEZONE_REQUEST: {
      return true;
    }
    case SET_TIMEZONE_RESPONSE:
    case SET_TIMEZONE_ERROR: {
      return false;
    }
    default: {
      return state;
    }
  }
};

const isLoadingGetTimezone = (state = false, { type }) => {
  switch (type) {
    case GET_TIMEZONES_REQUEST: {
      return true;
    }
    case GET_TIMEZONES_RESPONSE:
    case GET_TIMEZONES_ERROR: {
      return false;
    }
    default: {
      return state;
    }
  }
};

const reducer = combineReducers({
  enableForumLoading,
  forumEnabled,
  forumCategorySlug,
  syncForumLoading,
  getTimezones,
  isSettingTimezone,
  isLoadingGetTimezone,
  isLoadingSetTimezone,
});

export default resetOnLogoutReducer(reducer);
